import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="legal-page" data-testid="privacy-page">
      <header className="legal-header">
        <Link to="/" className="legal-back" data-testid="privacy-back-link">
          <ArrowLeft size={18} />
          Volver
        </Link>
        <h1>Política de Privacidad — SUCO</h1>
        <p className="legal-updated">Última actualización: 3 de junio de 2026</p>
      </header>

      <main className="legal-content">
        <section>
          <h2>1. Responsable del tratamiento de datos</h2>
          <p>
            <strong>Juan José Mora Dávalos</strong>, persona física con actividades empresariales,
            propietario y operador de la plataforma <strong>SUCO</strong> (sucomx.com), con domicilio en
            Retorno Loma Valentina 11421-B, Col. Loma de Virreyes, Tijuana, Baja California, C.P. 22245, México.
          </p>
          <p>
            Contacto: <a href="mailto:info@sucomx.com">info@sucomx.com</a>
          </p>
        </section>

        <section>
          <h2>2. Datos personales que recopilamos</h2>
          <p>SUCO recopila únicamente los datos estrictamente necesarios para prestar el servicio:</p>
          <ul>
            <li><strong>De negocios suscriptores:</strong> nombre del negocio, correo electrónico, teléfono, idioma preferido, logotipo (opcional), datos de pago (procesados de forma segura por Stripe y PayPal, no almacenamos tarjetas).</li>
            <li><strong>De clientes finales que dejan retroalimentación:</strong> tipo de mensaje (queja o sugerencia), texto del mensaje, y de manera <em>opcional</em> nombre, correo y teléfono si el usuario decide proporcionarlos.</li>
            <li><strong>Datos técnicos automáticos:</strong> dirección IP, tipo de dispositivo, navegador, hora de acceso, exclusivamente para fines de seguridad y mejora del servicio.</li>
          </ul>
        </section>

        <section>
          <h2>3. Finalidad del tratamiento</h2>
          <ul>
            <li>Operar y mantener la plataforma SUCO.</li>
            <li>Generar códigos QR, carteles y reportes para los negocios suscritos.</li>
            <li>Enviar notificaciones por correo electrónico al negocio cuando reciben nuevas quejas o sugerencias.</li>
            <li>Procesar pagos de suscripciones a través de Stripe y PayPal.</li>
            <li>Mejorar la experiencia del usuario y prevenir abusos.</li>
          </ul>
        </section>

        <section>
          <h2>4. Cómo compartimos la información</h2>
          <p>
            <strong>No vendemos ni rentamos datos personales.</strong> Compartimos información únicamente con:
          </p>
          <ul>
            <li><strong>Stripe</strong> y <strong>PayPal</strong>: procesamiento seguro de pagos.</li>
            <li><strong>SendGrid (Twilio)</strong>: envío de notificaciones por correo electrónico.</li>
            <li><strong>Proveedores de infraestructura en la nube</strong> (Cloudflare, MongoDB Atlas, Emergent): almacenamiento y entrega del servicio.</li>
            <li><strong>Autoridades competentes</strong>: cuando exista un requerimiento legal válido.</li>
          </ul>
        </section>

        <section>
          <h2>5. Derechos ARCO</h2>
          <p>
            De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (México),
            tú tienes derecho a <strong>Acceder, Rectificar, Cancelar u Oponerte</strong> al tratamiento de tus datos personales.
            Para ejercer cualquiera de estos derechos, envía un correo a{" "}
            <a href="mailto:info@sucomx.com">info@sucomx.com</a> indicando claramente tu solicitud.
            Responderemos en un plazo máximo de 20 días hábiles.
          </p>
        </section>

        <section>
          <h2>6. Seguridad</h2>
          <p>
            Utilizamos cifrado HTTPS/TLS en todas las comunicaciones, almacenamiento cifrado de contraseñas (bcrypt),
            y procesadores de pago certificados PCI-DSS Nivel 1. Las contraseñas nunca se almacenan en texto plano.
          </p>
        </section>

        <section>
          <h2>7. Retención de datos</h2>
          <p>
            Conservamos los datos del negocio mientras la cuenta esté activa. Si cancelas tu suscripción,
            mantenemos la información durante 90 días por motivos contables y fiscales, después de los cuales se eliminan
            de forma segura.
          </p>
        </section>

        <section>
          <h2>8. Cookies y tecnologías similares</h2>
          <p>
            SUCO utiliza almacenamiento local del navegador (<code>localStorage</code>) para mantener tu sesión iniciada
            y guardar tus preferencias de idioma. No usamos cookies de rastreo publicitario ni de terceros con fines de marketing.
          </p>
        </section>

        <section>
          <h2>9. Menores de edad</h2>
          <p>
            SUCO es un servicio dirigido exclusivamente a personas mayores de 18 años, propietarios o representantes
            legales de negocios. No recopilamos intencionalmente datos de menores.
          </p>
        </section>

        <section>
          <h2>10. Cambios a esta política</h2>
          <p>
            Podemos actualizar esta Política de Privacidad ocasionalmente. Notificaremos los cambios importantes vía
            correo electrónico al titular de la cuenta y publicaremos la versión vigente en esta misma URL con la fecha de actualización.
          </p>
        </section>

        <section>
          <h2>11. Contacto</h2>
          <p>
            Para cualquier duda relacionada con esta política o el tratamiento de tus datos personales:
          </p>
          <p>
            <strong>Juan José Mora Dávalos</strong><br />
            Retorno Loma Valentina 11421-B<br />
            Col. Loma de Virreyes, Tijuana, B.C. C.P. 22245, México<br />
            Correo: <a href="mailto:info@sucomx.com">info@sucomx.com</a><br />
            Sitio web: <a href="https://sucomx.com">https://sucomx.com</a>
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} SUCO — Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
